import React from "react";

export const StruSoftLogo = () => {
  return (
    <div className="strusoft-svg-logo-box">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: "#fff" }}
        viewBox="0 0 214.7 44.4"
        className="strusoft-svg-logo"
      >
        <g>
          <path d="m22.4,9.2c-1.8-1.2-4.3-2.4-6.7-2.4-3.5,0-5.4,1.9-5.4,4.4,0,2.7,2.9,4.8,7.7,8.6,5.6,4.4,8.5,7.9,8.5,13s-5,11.2-14.3,11.2c-4.3,0-9.1-1.3-12.2-4.1l3-4.7c2.2,1.6,4.7,3.3,8.4,3.3,3.4,0,6.4-1.8,6.4-5.7,0-4.5-5.6-7.6-8.9-10.2-4-3.2-7.4-5.8-7.4-11.3S7.1,1.3,14.6,1.3c4.7,0,8.5,1.7,10.5,3.6l-2.7,4.3Z" />
          <path d="m40.4,14.2h7v4h-7v14.5c0,4.8,1.5,6.9,4.1,6.9,1.7,0,2.7-.5,3.8-1l1.4,3.9c-2.3,1.2-5.1,1.9-7.7,1.9-6.5,0-9.3-3.4-9.3-9.4v-16.8h-4.3v-4h4.1v-7.1l7.9-1.8v8.9Z" />
          <path d="m62.2,19.1h.1l1.6-2.3c.9-1.2,2.7-3.6,5.1-3.6,1.8,0,3.7.9,5.3,2.7l-3,5.4c-1.3-.6-2.1-1-3.7-1-2.7,0-5.4,2.2-5.4,8.6v14.5h-7.8V13.4h7.8v5.7Z" />
          <path d="m95.5,39.3c-2.8,2.8-5.4,4.4-9.1,4.4-6.3,0-10-3.8-10-11.2V13.4h7.9v17.9c0,4.1,1.8,6.8,5.6,6.8,2.7,0,5.6-2.3,5.6-7.7V13.4h9v30h-8.9v-4.1h-.1Z" />
          <path d="m131.5,9.2c-1.8-1.2-4.3-2.4-6.7-2.4-3.5,0-5.4,1.9-5.4,4.4,0,2.7,2.9,4.8,7.7,8.6,5.5,4.4,8.5,7.9,8.5,13s-5,11.2-14.3,11.2c-4.3,0-9.1-1.3-12.2-4.1l3-4.7c2.2,1.6,4.7,3.3,8.4,3.3,3.4,0,6.4-1.8,6.4-5.7,0-4.5-5.5-7.6-8.9-10.2-4-3.2-7.4-5.8-7.4-11.3s5.6-10,13.1-10c4.7,0,8.5,1.7,10.5,3.6l-2.7,4.3Z" />
          <path d="m139.5,28.5c0-9.6,7.6-15.1,15.5-15.1s15.5,5.5,15.5,15.1-6.3,15.8-15.5,15.8c-9.3,0-15.5-6.6-15.5-15.8Zm22.6,0c0-4.9-1.7-10.7-7.2-10.7s-7.1,5.8-7.1,10.7c0,5.2,1.5,11.5,7.1,11.5s7.2-6.3,7.2-11.5Z" />
          <path d="m176.4,43.4v-25h-5v-5h5v-2.9c0-7.7,5.5-10.5,9.9-10.5,1.8,0,4.1.2,6.1,1.3l-1.4,3.9c-1.1-.4-2.2-.5-3.4-.5s-3.4.7-3.4,4.4v4.3h7v5h-7v25h-7.8Z" />
          <path d="m205.4,14.2h8v4h-8v14.5c0,4.8,1.5,6.9,4.1,6.9,1.7,0,2.7-.5,3.8-1l1.4,3.9c-2.3,1.2-5.1,1.9-7.7,1.9-6.5,0-9.3-3.4-9.3-9.4v-16.8h-4.3v-4h4.1v-7.1l7.9-1.8v8.9Z" />
        </g>
      </svg>
    </div>
  );
};
